var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('ProjectsPgHeader'),_c('section',{staticClass:"form-full-width"},[_c('FormProjectsPg',{attrs:{"loading":_vm.loading,"getProjectsPg":_vm.getProjectsPg},on:{"beforeUpdate":_vm.updateProjectsPg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }